import type { API } from 'chessboard/api/config/types';
import type { Board } from 'chessboard/model/board/types';
import type { Game } from 'chessboard/model/game/types';
import { deduplicate } from 'src/utils/array/deduplicate';

/**
 * Create the getLegalMovesForSquare method.
 */
export function createGetLegalMovesForSquare(context: API.Context) {
  /**
   * Get an array of the legal moves for a given square.
   */
  return function getLegalMovesForSquare(square: Board.SanSquare): Board.SanSquare[] {
    return deduplicate(
      context.api
        .getLegalMoves()
        .filter(
          (gameMove: Game.Move.Model) => typeof square === 'undefined' || gameMove.from === square,
        )
        .map((gameMove: Game.Move.Model) => gameMove.to),
    );
  };
}
